import {getVerifyImageCode, sendEquity, getRecordList, getCode, actRegister} from "../../base/api/getActivityInfo";
export async function doGetVerifyImageCode(param) {
    let data;
    try {
        let params = param;
        data = await getVerifyImageCode(params);
        if (data.data.code == "0000") {
            let result = data.data.data;
            return {
                hasError: false,
                info: result
            };
        } else {
            window.globalVue.$Toast({
                message: data.data.msg
            });
            return {
                hasError: true
            };
        }
    } catch (error) {
        window.globalVue.$Toast({
            message: "请求出错"
        });
        return {
            hasError: true
        };
    }
}

export async function doSendEquity(param) {
    let data;
    try {
        let params = param;
        data = await sendEquity(params);
        if (data.data.code == "0000") {
            let result = data.data.data;
            return {
                hasError: false,
                info: result
            };
        } else {
            window.globalVue.$Toast({
                message: data.data.msg
            });
            return {
                hasError: true
            };
        }
    } catch (error) {
        window.globalVue.$Toast({
            message: "请求出错"
        });
        return {
            hasError: true
        };
    }
}

export async function doGetRecordList(param) {
    let data;
    try {
        data = await getRecordList(param);
        if (data.data.code == "0000") {
            let result = data.data.data.list;
            return {
                hasError: false,
                list: result
            };
        } else {
            window.globalVue.$Toast({
                message: data.data.msg
            });
            return {
                hasError: true
            };
        }
    } catch (error) {
        window.globalVue.$Toast({
            message: "请求出错"
        });
        return {
            hasError: true
        };
    }
}

export async function doGetCode(param) {
    let data;
    try {
        data = await getCode(param);
        if (data.data.code == "0000") {
            return {
                hasError: false
            };
        } else {
            window.globalVue.$Toast({
                message: data.data.msg
            });
            return {
                hasError: true
            };
        }
    } catch (error) {
        window.globalVue.$Toast({
            message: "请求出错"
        });
        return {
            hasError: true
        };
    }
}

export async function doActRegister(param) {
    let data;
    try {
        data = await actRegister(param);
        if (data.data.code == "0000") {
            return {
                hasError: false,
                info: data.data.data
            };
        } else {
            window.globalVue.$Toast({
                message: data.data.msg
            });
            return {
                hasError: true
            };
        }
    } catch (error) {
        window.globalVue.$Toast({
            message: "请求出错"
        });
        return {
            hasError: true
        };
    }
}